import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'planone-radio-input-bottom-sheet',
  templateUrl: './radio-input-bottom-sheet.component.html',
  styleUrls: ['./radio-input-bottom-sheet.component.scss'],
})
export class RadioInputBottomSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      value: string;
      options: { value: any; label: string; disabled?: boolean }[];
      label: string;
    },
    private bottomSheetRef: MatBottomSheetRef<RadioInputBottomSheetComponent>
  ) {}

  onClose() {
    this.bottomSheetRef.dismiss();
  }

  onSelectionChange(event: { value: any }) {
    this.bottomSheetRef.dismiss(event.value);
  }

  identifyOption(_index: number, option: { label: string }): string {
    return option.label;
  }
}
